import { gql } from "@apollo/client";

export default gql`
  fragment CollectionCardFields on Collection {
    _id
    name
    slug
    packaging
    tags {
      _id
      name
    }
    viewerDidBookmark
    contentCounters {
      groupsCount
      productsCount
      projectsCount
      storiesCount
      governmentsCount
    }
    displayOptions {
      cardBackgroundColorHex
      cardTitleFontColorHex
    }
  }
`;
